module.exports = __webpack_public_path__ + "img/depmap_svg_V163.0c31ee71.svg";